import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import Pagination from '../../../Pagination/Pagination'
import { connect } from 'react-redux'
import { currencyFormatter } from '../../../../modules/formatter'

const ProductsList = (props, { user }) => {
    const storeId = props.storeId
    const ProductList = props.ProductList
    const TotalProducts = props.TotalProducts
    const formatter = props.formatter
    const numberFormatter = props.numberFormatter
    const PageSize = props.PageSize
    const ProductInfo = props.ProductInfo
    const WarehouseDetails = props.WarehouseDetails
    const Sortby = props.Sortby
    const SortDirection = props.SortDirection
    const onSortChange = props.onSortChange
    const onPageSizeChange = props.onPageSizeChange
    const onSortDirectionChange = props.onSortDirectionChange
    const [expandedRows, setExpandedRows] = useState([])

    const toggleRow = (index) => {
        if (expandedRows.includes(index)) {
            // If the row is already expanded, collapse it
            setExpandedRows(expandedRows.filter((rowIndex) => rowIndex !== index))
        } else {
            // If the row is not expanded, expand it
            setExpandedRows([...expandedRows, index])
        }
    }
    return (
        <>

            <div className="card mb-0">
                <div className="card-body">
                    <div className="card-header pb-0 d-flex justify-content-between align-items-center">
                        <h4 className="card-title">Product List</h4>
                        <div className="graph-sets">
                            <div className="dropdown mx-1">
                                <button className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Page Size
                                </button>
                                <ul className="dropdown-menu">
                                    <li><a className={ PageSize === "10" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "10") } } href="#">10</a></li>
                                    <li><a className={ PageSize === "20" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "20") } } href="#">20</a></li>
                                    <li><a className={ PageSize === "50" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "50") } } href="#">50</a></li>
                                    <li><a className={ PageSize === "100" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onPageSizeChange(e, "100") } } href="#">100</a></li>
                                </ul>
                            </div>
                            <div className="dropdown">
                                <button className="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Sort by
                                </button>
                                <ul className="dropdown-menu">
                                    <li><a className={ Sortby === "sales" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "sales") } } href="#">Sales (Last 30 days)</a></li>
                                    <li><a className={ Sortby === "units" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "units") } } href="#">Units (Last 30 days)</a></li>
                                    <li><a className={ Sortby === "title" ? "dropdown-item active" : "dropdown-item" } onClick={ (e) => { onSortChange(e, "title") } } href="#">Title</a></li>
                                </ul>
                            </div>
                            <div className='py-1'>
                                <button
                                    onClick={ (e) => { onSortDirectionChange(e, "up") } }
                                    className={
                                        SortDirection === "up" ?
                                            'btn btn-primary mx-1 my-1'
                                            :
                                            'btn btn-outline-primary mx-1'
                                    }
                                >
                                    <i class="fa-solid fa-arrow-up-wide-short"></i>
                                </button>
                            </div>
                            <div className='py-1'>
                                <button
                                    onClick={ (e) => { onSortDirectionChange(e, "down") } }
                                    className={
                                        SortDirection === "down" ?
                                            'btn btn-primary mx-1'
                                            :
                                            'btn btn-outline-primary mx-1 my-1'
                                    }
                                >
                                    <i class="fa-solid fa-arrow-down-wide-short"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="table-responsive text-wrap">
                        <table className="table mb-0">
                            <thead>

                                <tr>
                                    <th>
                                        Title
                                    </th>
                                    <th >
                                        View
                                    </th>
                                    {
                                        Sortby === "sales" || Sortby === "units" ?
                                            <>
                                                <td>
                                                    Units
                                                </td>
                                                <td>
                                                    Sales
                                                </td>
                                            </>
                                            : <></>
                                    }
                                    <th >
                                        Variants
                                    </th>
                                    <th >
                                        Price
                                    </th>
                                    <th >
                                        SKU
                                    </th>
                                    <th >
                                        Barcode
                                    </th>
                                    <th >
                                        Cost
                                    </th>
                                    <th>
                                        Status
                                        {/* {
                                            Sortby !== "sales" && Sortby !== "units" ?
                                                <select className="form-select" name='status' value={ props.StatusFilters['status'] } onChange={ (e) => { props.onStatusFilterChange(e) } } id='statusFilter' aria-label="Default select example">
                                                    <option value="All">All</option>
                                                    <option value="active">Active</option>
                                                    <option value="draft">Draft</option>
                                                </select>
                                                : <></>
                                        } */}
                                    </th>
                                    <th >
                                        Total Stock
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    !ProductList?.loading ?
                                        ProductList.map(
                                            (key, index) => {
                                                return (

                                                    <>
                                                        <tr key={ index }>
                                                            <td>
                                                                <img src={ key.image_url } alt="Avatar" className="rounded-circle avatar avatar-md pull-up" />

                                                                <button style={ { border: 'none', backgroundColor: 'transparent' } } onClick={ (e) => { props.LoadProductDetails(key.product_id) } } data-bs-toggle="modal" data-bs-target={ "#productDetailsModal-" + storeId }>{ key?.title?.substring(0, 45) }...</button>

                                                            </td>
                                                            <td>
                                                                <a href={ key?.url } target='_blank' style={ { color: 'white' } } className={ "btn btn-primary me-1 bg-label-success" }>
                                                                    <span>Product Link</span>
                                                                </a>
                                                            </td>
                                                            {
                                                                Sortby === "sales" || Sortby === "units" ?
                                                                    <>
                                                                        <td>
                                                                            { numberFormatter.format(key?.units) }
                                                                        </td>
                                                                        <td>
                                                                            { currencyFormatter('en-ZA', 'ZAR').format(key?.sales) }
                                                                        </td>
                                                                    </>
                                                                    :
                                                                    <></>
                                                            }
                                                            <td>
                                                                {
                                                                    key.variants == 1 ?
                                                                        numberFormatter.format(key.variants)
                                                                        :
                                                                        <button onClick={ (e) => { toggleRow(index); } } className={ "btn btn-primary me-1 bg-label-success" }>View { key.variants } Variants</button>
                                                                }
                                                            </td>
                                                            <td>
                                                                { key.variants == 1 ? formatter.format(key?.variants_data[0]['price']) : `Starts from ${formatter.format(key?.variants_data.reduce((min, variant) => { return Math.min(min, variant.price); }, Number.MAX_VALUE))}` }
                                                            </td>
                                                            <td>
                                                                { key?.variants_data[0]['sku'] }
                                                            </td>
                                                            <td>
                                                                { key?.variants_data[0]['barcode'] }
                                                            </td>
                                                            <td>
                                                                <a >{ formatter.format(key.total_cost_per_unit) }</a>
                                                            </td>
                                                            <td>

                                                                { key.status }

                                                            </td>
                                                            <td>{ numberFormatter.format(key.stock) }</td>
                                                        </tr>
                                                        { expandedRows.includes(index) &&
                                                            key.variants_data.map(
                                                                (variant, index) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={ index }>
                                                                                <td>
                                                                                    <img src={ variant.image_url != "" ? variant.image_url : key.image_url } alt="Avatar" className="rounded-circle avatar avatar-md pull-up" />
                                                                                    <button style={ { border: 'none', backgroundColor: 'transparent' } } onClick={ (e) => { props.LoadProductDetails(key.tsin_id, key?.sku) } } data-bs-toggle="modal" data-bs-target={ "#productDetailsModal-" + storeId }>Variant { index + 1 }:{ key?.title?.substring(0, 45) }...</button>

                                                                                </td>
                                                                                <td>
                                                                                    <a href={ key?.url } target='_blank' style={ { color: 'white' } } className={ "btn btn-primary me-1 bg-label-success" }>
                                                                                        <span>Product Link</span>
                                                                                    </a>
                                                                                </td>
                                                                                {
                                                                                    Sortby === "sales" || Sortby === "units" ?
                                                                                        <>
                                                                                            <td>
                                                                                                { numberFormatter.format(key?.units) }
                                                                                            </td>
                                                                                            <td>
                                                                                                { currencyFormatter('en-ZA', 'ZAR').format(key?.sales) }
                                                                                            </td>
                                                                                        </>
                                                                                        :
                                                                                        <></>
                                                                                }
                                                                                <td>
                                                                                    { numberFormatter.format(key.variants) }
                                                                                </td>
                                                                                <td>
                                                                                    { formatter.format(variant['price']) }
                                                                                </td>
                                                                                <td>
                                                                                    { formatter.format(variant['sku']) }
                                                                                </td>
                                                                                <td>
                                                                                    { formatter.format(variant['barcode']) }
                                                                                </td>
                                                                                <td>
                                                                                    <a >{ formatter.format(key.total_cost_per_unit) }</a>
                                                                                </td>
                                                                                <td>
                                                                                    {
                                                                                        key.status === "active" ?
                                                                                            <span className="bg-label-primary ">
                                                                                                { key.status }
                                                                                            </span> :
                                                                                            key.status === "draft" ?
                                                                                                <span className="bg-label-danger ">
                                                                                                    { key.status }
                                                                                                </span>
                                                                                                :
                                                                                                <span className="bg-label-secondary ">
                                                                                                    { key.status }
                                                                                                </span>
                                                                                    }
                                                                                </td>
                                                                                <td>{ numberFormatter.format(variant.variant_stock) }</td>
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                }
                                                            )
                                                        }
                                                    </>
                                                )
                                            })
                                        :
                                        Array.from({ length: PageSize }).map((_, index) => (
                                            <tr key={ index }>
                                                <td className="productimgname">
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                                <td>
                                                    <h5>
                                                        <span className="skeleton-loader"></span>
                                                    </h5>
                                                </td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                        <br />
                        <div className='pagination justify-content-center'>
                            {
                                TotalProducts > 0 ?
                                    <Pagination totalPages={ props.TotalPages } totalRecords={ TotalProducts } pageLimit={ PageSize } sortBy={ Sortby } sortDirection={ SortDirection } paginationFilters={ props.StatusFilters } paginationSearchQuery={ props.SearchQuery } paginationPageSize={ props.PageSize } accountId={ props.user.id } dashboard={ storeId } paginationOrderBy={ props.OrderBy } onPageChanged={ props.loadProductList } />
                                    // <Pagination  totalRecords={TotalProducts} pageLimit={props.PageSize} paginationFilters={props.StatusFilters} paginationSearchQuery={props.SearchQuery} accountId={props.user.id} dashboard={1} paginationOrderBy={props.OrderBy} onPageChanged={props.loadProductList} />
                                    : <></>
                            }
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

const mapStateToProps = state => ({
    isAuthenticated: state.Auth.isAuthenticated,
    user: state.Auth.user,
})

export default connect(mapStateToProps)(ProductsList)